import OptionsPanel from "components/panels/OptionsPanel";
import React from "react";
import BrandLogo from "../components/BrandLogo";
import InvitationMessage from "../components/invitation/InvitationMessage";

interface Props {
  brand: server.dto.BrandSmall
  invitationBody: string
  message: string

  completedUtc: Date

  docUrl: string
}

const FinishedBrandInfoPanel = (props: Props) => {
  return <OptionsPanel
    title={<div className="margin-bottom-large">
      <BrandLogo brand={props.brand} boxWhenNoImage />
    </div>}
  >
    <InvitationMessage
      message={props.message}
      className="margin-bottom-large"
      brandName={props.brand.name}
    />

    <a href={props.docUrl} className="button-new primary big fluid">
      <span className="margin-right">
        <i className="icon-download" />

      </span>

      {RESX.ESign.DownloadDocument}
    </a>

  </OptionsPanel>;
};

export default FinishedBrandInfoPanel;